import { Component, Inject } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { RulevarService } from 'src/app/rule/rulevar.service';
import { getObjectDiff } from "@donedeal0/superdiff";

@Component({
  selector: 'app-edit-intel-list',
  templateUrl: './edit-intel-list.component.html',
  styleUrls: ['./edit-intel-list.component.scss']
})
export class EditIntelListComponent {

  constructor(
    public rulevarservice:RulevarService,
    @Inject(MAT_DIALOG_DATA) public data:any,
    private ref:MatDialogRef<EditIntelListComponent>,
  ){}

  editForm = new FormGroup({})

  oldValue={}

  ngOnInit(){
    this.oldValue=JSON.parse(JSON.stringify(this.data))
    this.buildControl(this.rulevarservice.intel_view.fields)
    this.setDefaultValues()
  }

  buildControl(list){
    list.forEach(field=>{
      this.editForm.addControl(field.fieldName,new FormControl(),{emitEvent:false})
      if(!field.isNull){
        this.editForm.get(field.fieldName).setValidators(Validators.required)
      }
      if(field.dataType === "text"){
        this.editForm.get(field.fieldName).setValidators(this.rulevarservice.textValidator(field.isNull))
      }else if(field.dataType === "number"){
        this.editForm.get(field.fieldName).setValidators(this.rulevarservice.numberValidator(field.isNull))
      }else if(field.dataType === "inet"){
        this.editForm.get(field.fieldName).setValidators(this.rulevarservice.ipValidator(field.isNull))
      }
    })
  }


  setDefaultValues(){
    this.editForm.patchValue(this.data)
  }
  submitClicked(){
    let index = this.rulevarservice.intel_view_copy.findIndex(val=> val.uniqueKey === this.data.uniqueKey)

    if(index !=-1 && index != null){
      Object.keys(this.rulevarservice.intel_view_copy[index]).forEach(val=>{
        if(val != 'uniqueKey'){
          this.rulevarservice.intel_view_copy[index][val]=this.editForm.get(val).value
        }
      })
    }

    let indexFilter = this.rulevarservice.intel_view_filtered.findIndex(val=> val.uniqueKey === this.data.uniqueKey)

    if(indexFilter !=-1 && indexFilter != null){
      Object.keys(this.rulevarservice.intel_view_filtered[indexFilter]).forEach(val=>{
        if(val != 'uniqueKey'){
          this.rulevarservice.intel_view_filtered[indexFilter][val]=this.editForm.get(val).value
        }
      })
    }

    if(getObjectDiff(this.oldValue,this.rulevarservice.intel_view_copy[index]).status === 'updated'){
      let obj ={"old":this.oldValue,"new":this.rulevarservice.intel_view_copy[index]}

      let editIndex = this.rulevarservice.viewIntelEditList.findIndex(val => val.old.uniqueKey === this.data.uniqueKey)


      if(editIndex != -1 && editIndex != null){
        if(getObjectDiff(this.rulevarservice.viewIntelEditList[editIndex].old,this.rulevarservice.viewIntelEditList[editIndex].new).status ==="equal"){
          this.rulevarservice.viewIntelEditList.splice(editIndex,1)
        }
      }else{
        this.rulevarservice.viewIntelEditList.push(obj)
      }

      
    }

//console.log(this.rulevarservice.viewIntelEditList)
    this.ref.close()
  }
  closeClick(){
    this.ref.close()
  }

}
